import { LitElement, html, css } from 'lit';
import { validateForm, validatePassword, gRecaptcha, validationHandler, validationHandlerClear, hideRevealPassword, languages } from '../../utilities/formsUtilities';
import { accessibility, formStyles } from '../../utilities/styles';
import { eyeSvg, completedPageIcon, dots, arrowBack, editIcon, deleteIcon, dashIcon } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
import { cache } from 'lit/directives/cache.js';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInAccountDetails extends LitElement {
    static properties = {
        action: { type: String },
        restUrl: { type: String },
        nonce: { type: String },
        config_user: { type: Object, reflect: true },
        config_hardlinks: { type: Object, reflect: true },
        user: { type: Object, state: true },
        showForm: { type: String, reflect: true },
        name: { type: String },
        hardlinks: { type: Object, state: true },
        _removeAccount: { state: true },
    };
    constructor() {
        super();
    }
    connectedCallback() {
        super.connectedCallback();
        this._removeAccount = false;
        this.eventManager = new EventManager(this);
        if (this.config_user) {
            this.user = this.config_user;
        }
        if (this.config_hardlinks) {
            this.hardlinks = this.config_hardlinks;
        }
        this.config_user = null;
        this.config_hardlinks = null;
    }
    get form() {
        return this.shadowRoot.querySelector('form');
    }
    get formResponse() {
        return this.shadowRoot.querySelector('.message');
    }
    get submitButton() {
        return this.shadowRoot.querySelector('input[type="submit"]');
    }
    get returnButton() {
        return this.shadowRoot.querySelector('.return');
    }
    render() {
        let markup = '';
        if (this.showForm == 'true') {
            markup = html `\n                <button @click=${this._handleEditClick} class="return" title="Canslo">\n                    <span aria-hidden="true">${arrowBack}</span>\n                    Mynd n\u00F4l\n                </button>\n                <p>Cyfeiriad e-bost presennol: <strong class="underline tabspace">${this.user.email}</strong></p>\n                <form action="${this.action}" method="post" @submit=${this._submit}>\n                    <div class="message notice" aria-live="polite"></div>\n                    <fieldset>\n                        <legend>Newid enw</legend>\n                        <div class="bg">\n                            <div class="input-group">\n                                <label for="firstname">Enw cyntaf*</label>\n                                <input type="text" name="firstname" id="firstname" aria-required value="${this.user.firstName}">\n                            </div>\n                            <div class="input-group">\n                                <label for="lastname">Cyfenw*</label>\n                                <input type="text" name="lastname" id="lastname" aria-required value="${this.user.lastName}">\n                            </div>\n                        </div>\n                    </fieldset>\n                    <input type="hidden" value="${this.action}_name" name="action">\n                    <input type="submit" value="Newid enw">\n                </form>\n                <form action="${this.action}" method="post" @submit=${this._submit}>\n                    <div class="message notice" aria-live="polite"></div>\n                    \n                    <fieldset> \n                        <legend>Newid y cyfrinair</legend>\n                        <div class="bg">\n                            <div class="input-group">\n                                <label for="password">Cyfrinair newydd*</label>\n                                <div class="pword_wrapper">\n                                    <input type="password" name="password" id="password" aria-required @change=${this._onPasswordChange}>\n                                    <button data-switch="password" aria-label="Dangos cyfrinair" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>\n                                    ${eyeSvg} Dangos cyfrinair</button>\n                                </div>\n                            </div>\n                            <div class="input-group">\n                                <label for="password_confirm">Cadarnhau\u2019r cyfrinair*</label>   \n                                <div class="pword_wrapper">\n                                    <input type="password" name="password_confirm" id="password_confirm" aria-required @change=${this._onPasswordConfirmChange}>\n                                    <button data-switch="password_confirm" aria-label="Dangos cyfrinair" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>\n                                    ${eyeSvg} Dangos cyfrinair</button>\n                                </div>\n                            </div>\n                            <p>Byddwch yn cael eich allgofnodi ar \u00F4l newid eich cyfrinair</p>\n                        </div>\n                    </fieldset>\n                    <input type="hidden" value="${this.action}_password" name="action">\n                    <input type="submit" value="Newid y cyfrinair">\n                </form> \n                <form action="${this.action}" method="post" @submit=${this._submit}>\n                    <div class="message notice" aria-live="polite"></div>\n                    <fieldset>\n                        <legend>Newid dewisiadau e-bost</legend>\n                        <div class="bg">\n                            ${this.user.emailPreferences.map((el, i) => {
                let input = '';
                if (el.selected === true && i == 0) {
                    input = html `<input type="checkbox" name="${el.value}" checked aria-required="true" id="email_preferences_${i}"   />`;
                }
                else if (el.selected === true) {
                    input = html `<input type="checkbox" name="${el.value}" checked id="email_preferences_${i}"  />`;
                }
                else {
                    input = html `<input type="checkbox" name="${el.value}" id="email_preferences_${i}"  />`;
                }
                return html `\n                                        <div class="input-group check-group check-group-reverse">\n                                            <label for="email_preferences_${i}">${el.name} ${i == 0 ? '*' : ''}</label>\n                                            ${input}\n                                        </div>\n                                    `;
            })}\n                            </div>\n                        </div>\n                    </fieldset>\n                    <input type="hidden" value="${this.action}_email_preferences" name="action">\n                    <input type="submit" value="Newid dewisiadau e-bost">\n                </form>\n                <form action="${this.action}" method="post" @submit=${this._submit}>\n                    <div class="message notice" aria-live="polite"></div>\n                    <fieldset>\n                        <legend>Newid dewisiadau iaith</legend>\n                        <div class="bg">\n                            <label for="language_preference">Dewis iaith</label>\n                            <select name="language_preference" id="language_preference">\n                                <option value="en" ?selected=${this.user.languagePreference == 'en' || !this.user.language}>Saesneg</option>\n                                <option value="cy" ?selected=${this.user.languagePreference == 'cy'}>Cymraeg</option>\n                                <!-- <option value="ga" ?selected=${this.user.languagePreference == 'ga'}>Gaeilge</option> -->\n                                <option value="gd" ?selected=${this.user.languagePreference == 'gd'}>Gwyddeleg</option>\n                            </select>\n                        </div>\n                    </fieldset>\n                    <input type="hidden" value="${this.action}_language_preferences" name="action">\n                    <input type="submit" value="Newid dewisiadau iaith">\n                </form>\n            `;
        }
        else if (this._removeAccount) {
            markup = html `\n                <button @click=${this._handleDeleteClick} class="return" title="Canslo">\n                    <span aria-hidden="true">${arrowBack}</span>\n                    Mynd n\u00F4l\n                </button>\n                <form action="${this.action}" method="post" @submit=${this._submit}>\n                    <div class="message notice" aria-live="polite"></div>\n                    \n                    <fieldset>\n                        <legend>Tynnu cyfrif</legend>\n                        <div class="bg">\n                            <p>Ydych chi'n si\u0175r eich bod am dynnu eich cyfrif?</p>\n                        </div>\n                    </fieldset>\n                    <input type="hidden" value="${this.action}_delete" name="action">\n                    <input type="submit" value="Tynnu cyfrif">\n                </form>\n            `;
        }
        else {
            let links = [];
            if (this.user.hasOrg) {
                links.push(html `<a href="${this.hardlinks.organisation_dashboard}" class="button">Rheoli eich sefydliad</a>`);
            }
            if (this.user.membershipID) {
                links.push(html `<a href="${this.hardlinks.dashboard}" class="button">Rheoli eich aelodaeth</a>`);
            }
            markup = html `\n                <allin-greeting username=${this.user.firstName} loggedin></allin-greeting>\n                <div class="bg">\n                    <table>\n                        <thead class="screen-reader-text">\n                            <tr>\n                                <th>Maes</th>\n                                <th>Gwerth</th>\n                            </tr>\n                        </thead>\n                        <tbody>\n                            <tr>\n                                <td>Enw</td>\n                                <td>${this.user.firstName} ${this.user.lastName}</td>\n                            </tr>\n                            <tr>\n                                <td>E-bost</td>\n                                <td>${this.user.email}</td>\n                            </tr>\n                            <tr>\n                                <td>Cyfrinair</td>\n                                <td>${dots}</td>\n                            </tr>\n                            <tr> \n                                <td>Fy newisiadau e-bost</td>\n                                <td><ul>${this.user.emailPreferences.map((el) => {
                let icon = '';
                let status = 'unselected';
                let classes = '';
                if (el.selected == true) {
                    icon = completedPageIcon;
                    status = 'selected';
                    classes = 'selected';
                }
                return html `<li class="${classes}"><span aria-hidden="true">${icon}</span><span class="screen-reader-text">${status}</span>${el.name}</li>`;
            })}</ul>\n                                </td>\n                            </tr>\n                            <tr>\n                                <td>Fy newis iaith</td>\n                                <td>${this.user.languagePreference ? languages[this.user.languagePreference] : languages['English']}</td>\n                            </tr>\n                        </tbody>\n                    </table>\n                    <div class="button-group border-top">\n                        <button @click=${this._handleEditClick} title=${`Golygu\u2019r manylion hyn`}><span aria-hidden="true">${editIcon}</span>Golygu\u2019r manylion hyn</button>\n                    </div>\n                </div>\n                ${links}\n                `;
            // Removed until we have an endpoint for this action
            //     <button @click=${this._handleDeleteClick} title=${msg('Remove my account',{desc:'button to delete user account'})}><span aria-hidden="true">${deleteIcon}</span>${msg('Remove my account',{desc:'button to delete user account'})}</button>
        }
        return html ` \n            <div class="my-account">\n                ${cache(markup)}\n            </div>\n        `;
    }
    _onPasswordChange(e) {
        e.preventDefault();
        let passwordField = e.target;
        let form = passwordField.closest('form');
        let submitButton = form.querySelector('input[type="submit"]');
        validationHandlerClear(passwordField);
        let valid = validatePassword(passwordField.value);
        if (valid !== true) {
            let error_message = valid.join('<br>');
            validationHandler(passwordField, error_message);
            submitButton.disabled = true;
        }
        let passwordConfirmField = form.querySelector('#password_confirm');
        if (passwordConfirmField.value) {
            if (passwordField.value !== passwordConfirmField.value) {
                valid = false;
                validationHandler(passwordConfirmField, `Mae\u2019r cyfrineiriau yn wahanol`);
                submitButton.disabled = true;
            }
            else {
                validationHandlerClear(passwordConfirmField);
            }
        }
        if (valid) {
            submitButton.disabled = false;
        }
    }
    _onPasswordConfirmChange(e) {
        e.preventDefault();
        let passwordConfirmField = e.target;
        let form = passwordConfirmField.closest('form');
        let submitButton = form.querySelector('input[type="submit"]');
        validationHandlerClear(passwordConfirmField);
        let passwordField = form.querySelector('#password');
        if (passwordField.value !== passwordConfirmField.value) {
            validationHandler(passwordConfirmField, `Mae\u2019r cyfrineiriau yn wahanol`);
            submitButton.disabled = true;
        }
        else {
            validationHandlerClear(passwordConfirmField);
            submitButton.disabled = false;
        }
    }
    _handleEditClick(e) {
        e.preventDefault();
        if (this.showForm == 'true') {
            this.showForm = 'false';
            this._dispatchChangeEvent('', true);
            setTimeout(() => { this.renderRoot.querySelector('button').focus(); }, 200);
            this._dispatchNewPageEvent(`${window.location.pathname}`);
        }
        else {
            this.showForm = 'true';
            this._dispatchChangeEvent(`Manylion Fy Nghyfrif`, false);
            setTimeout(() => { this.form.querySelector('input:not([type=hidden])').focus(); }, 200);
            this._dispatchNewPageEvent(`${window.location.pathname}?form_open=true`);
        }
    }
    _dispatchNewPageEvent(url) {
        this.eventManager.emit(`allin-navigation-${this.name}`, url, true);
        this.eventManager.addHistory(url);
    }
    _handleDeleteClick(e) {
        e.preventDefault();
        if (this._removeAccount) {
            this._removeAccount = false;
            this._dispatchChangeEvent('', true);
            setTimeout(() => { this.renderRoot.querySelector('button').focus(); }, 200);
        }
        else {
            this._removeAccount = true;
            this._dispatchChangeEvent(`Dileu eich cyfrif`, false);
            setTimeout(() => { this.form.querySelector('input:not([type=hidden])').focus(); }, 200);
        }
    }
    _dispatchChangeEvent(title, status) {
        this.eventManager.emit(`allin-header-${this.name}`, {
            text: title,
            name: this.name,
            revert: status
        });
    }
    async _submit(e) {
        e.preventDefault();
        let form = e.target;
        let formResponse = form.querySelector('.message');
        let submitButton = form.querySelector('input[type="submit"]');
        let valid = validateForm(form, formResponse);
        if (!valid)
            return;
        let formData = new FormData(form);
        formData = JSON.stringify(Object.fromEntries(formData));
        form.classList.add('loading');
        formResponse.innerHTML = '';
        formResponse.classList.remove('error');
        formResponse.classList.remove('success');
        submitButton.disabled = true;
        this.returnButton.disabled = true;
        form.setAttribute('aria-busy', 'true');
        try {
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                }
            });
            //show logged out modal if session has expired
            if (response.status === 403) {
                handle403s();
                return;
            }
            response = await response.json();
            if (response.ok) {
                form.classList.remove('loading');
                form.setAttribute('aria-busy', 'false');
                this.returnButton.disabled = false;
                submitButton.disabled = false;
                formResponse.innerHTML = response.message;
                formResponse.classList.add('success');
                if (response.userData) {
                    this._setUserData(response.userData);
                }
                if (response.redirect) {
                    window.location.href = response.redirect;
                }
            }
            else {
                form.classList.remove('loading');
                form.setAttribute('aria-busy', 'false');
                submitButton.disabled = false;
                this.returnButton.disabled = false;
                formResponse.innerHTML = response.message;
                formResponse.classList.add('error');
            }
        }
        catch (error) {
            console.error('Error:', error);
        }
        ;
    }
    _setUserData(data) {
        this.user = data;
    }
    static styles = [
        accessibility,
        formStyles,
        css `
        allin-greeting{
            --allin-font-size: 1.5rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }

        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child{
            width:40%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:60%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        ul li{
            display:grid;
            grid-template-columns:1.2rem 1fr;
            gap:0.5rem;
            margin-bottom:0.5rem;
            min-width: 0;

            &,
            > *:last-child {
                min-width: 0;
                white-space: normal;
                word-break: normal;
                overflow-wrap: anywhere;
            }
        }
        .error ul li{
            display:block;
        }
        ul li span:first-child{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
            height:1rem;
            background-color:#fff;
            border:1px solid var(--allin-text-color,#000);
            opacity:0.6;
        }
        ul li.selected span:first-child{
            background-color:var(--allin-primary-color,#FFC845);
        }
        form+form{
            margin-top:2rem;
        }
        .button{
            margin-top:1rem;
            width:100%;
            display: block;
            text-align: center;
            box-sizing:border-box;
        }
        @media (prefers-reduced-motion: reduce) {
            .button-group button svg, .return svg{
                transform: none;
            }
        }
        `
    ];
}
